import React from 'react';

import {
  Grid
} from '@mui/material';
import QuantItems from '../../components/Search/Filters/QuantItems';
import { DateRangeInput } from '../../components/Search/Filters/DateRangeInput';
import Neighborhood from '../../components/Search/Filters/Neighborhood';
import Area from '../../components/Search/Filters/Area';
import Target from '../../components/Search/Filters/Target';
import Group from '../../components/Search/Filters/Group';
import Status from '../../components/Search/Filters/Status';
import Forwarded from '../../components/Search/Filters/Fowarded';
import Late from '../../components/Search/Filters/Late';
import UserPermission from '../../components/UserPermission';
import StepStatus from '../../components/Search/Filters/StepStatus';
import Executor from '../../components/Search/Filters/Executor';
import Controlador from '../../components/Search/Filters/Controlador';

const userPermission = UserPermission();

export default function FiltersComplaints() {

  return (
    <div id="complaints-filter" className="filtros">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <QuantItems />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <Neighborhood />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <Area />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <Target />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <Group />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <Status />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <DateRangeInput />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <StepStatus />
        </Grid>

        {
          userPermission !== 'executor' ?
            <>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Forwarded />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Late />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Controlador />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Executor />
              </Grid>
            </>
            : false
        }

      </Grid>
    </div >
  );
}